(function (Drupal, once) {

  // Drupal.behaviors.initiativeMap = {
  //   attach: function (context, settings) {
  //     // Attach once per page load.
  //     once('initiativeMap', '#map', context).forEach(function (mapContainer) {
  //       const coords = settings?.initiatives?.field_initiatives_geolocation?.[0];
  //
  //       // Stop if no coordinates.
  //       if (!coords || !coords.lat || !coords.lng) {
  //         console.warn('No geolocation data found for this initiative.');
  //         return;
  //       }
  //
  //       // Get Mapbox token (use your helper or hardcode temporarily)
  //       mapboxgl.accessToken = Drupal.hypeUtils.getMapboxToken();
  //
  //       // Create the map
  //       const map = new mapboxgl.Map({
  //         container: mapContainer,
  //         style: 'mapbox://styles/mapbox/standard',
  //         center: [coords.lng, coords.lat],
  //         zoom: 13,
  //       });
  //
  //       // Add zoom/rotation controls
  //       map.addControl(new mapboxgl.NavigationControl());
  //
  //       // Create a simple styled marker
  //       const el = document.createElement('div');
  //       el.className = 'initiative-marker';
  //       el.style.width = '30px';
  //       el.style.height = '30px';
  //       el.style.borderRadius = '50%';
  //       el.style.backgroundColor = '#0074D9';
  //       el.style.border = '3px solid white';
  //       el.style.boxShadow = '0 0 6px rgba(0,0,0,0.3)';
  //       el.style.cursor = 'default';
  //
  //       // Add marker to the map
  //       new mapboxgl.Marker(el)
  //         .setLngLat([coords.lng, coords.lat])
  //         .addTo(map);
  //
  //       console.info('Map created at:', coords.lat, coords.lng);
  //     });
  //   },
  // };
})(Drupal, once);
